import React from 'react';
import { EvaluateAppDialog } from '../../../../modules/dialogs/components/evaluate-app-dialog/evaluate-app-dialog';
import { NativeAppDialog } from '../../../../modules/dialogs/components/native-app-dialog/native-app-dialog';
import { useDialogsShared } from '../../../../modules/dialogs/hooks/use-dialogs-shared';
import { UpdateControllerDialog } from './components/update-controller-dialog/update-controller-dialog';
import { UpdateDevicesDialog } from './components/update-devices-dialog/update-devices-dialog';
import { useUpdateController } from './hooks/use-update-controller';
import { useUpdateDevices } from './hooks/use-update-devices';

export const DialogsExalus: React.FC = () => {
  const { nativeAppOpen, evaluateAppOpen, setEvaluatePopupOpen } = useDialogsShared();
  const { updateControllerOpen, setUpdateControllerOpen, handleSaveControllerMemoryForInstallationId } =
    useUpdateController();
  const { updateDevicesOpen, setUpdateDevicesOpen, handleSaveDevicesMemoryForInstallationId } = useUpdateDevices();

  if (nativeAppOpen) {
    return <NativeAppDialog />;
  }

  if (evaluateAppOpen) {
    return <EvaluateAppDialog showDialog={evaluateAppOpen} setShowDialog={setEvaluatePopupOpen} />;
  }

  if (updateControllerOpen) {
    return (
      <UpdateControllerDialog
        showDialog={updateControllerOpen}
        setShowDialog={setUpdateControllerOpen}
        handleSaveControllerMemoryForInstallationId={handleSaveControllerMemoryForInstallationId}
      />
    );
  }

  if (updateDevicesOpen) {
    return (
      <UpdateDevicesDialog
        showDialog={updateDevicesOpen}
        setShowDialog={setUpdateDevicesOpen}
        handleSaveDevicesMemoryForInstallationId={handleSaveDevicesMemoryForInstallationId}
      />
    );
  }

  return null;
};
